import { EMAIL_ADD, PHONE, PHONE_NUMBER, OFFICE_HOURS} from './constants'
import { ReactComponent as PhoneIcon } from '../assets/phone.svg';
import { ReactComponent as MailIcon } from '../assets/mail.svg';
import { ReactComponent as ClockIcon } from '../assets/clock.svg';

export default function AboveNav() {

    return(
        <div className="border-b border-zinc-800 bg-[#0b0b0b] text-zinc-400 lg:block sm:hidden">
            <div className="mx-auto flex max-w-maxScreen items-center justify-between gap-3 px-5 py-3 lg:px-10">
               <div className='flex gap-3'>
                    <div className='flex items-center gap-2'>
                        <PhoneIcon className="w-4 h-4" aria-hidden="true" />
                        <a href={`tel:${PHONE}`} className="text-sm transition hover:text-white">
                        {PHONE_NUMBER}
                        </a>
                    </div>
                    <div className='items-center'>·</div>
                    <div className='flex items-center gap-2'>
                        <MailIcon className="w-4 h-4" aria-hidden="true" />
                        <a href={`mailto:${EMAIL_ADD}`} className="text-sm transition hover:text-white">
                        {EMAIL_ADD}
                        </a>
                    </div>
                    <div className='items-center'>·</div>
                    <div className='flex items-center gap-2'>
                        <ClockIcon className="w-4 h-4" aria-hidden="true" />
                        <a href={`mailto:${EMAIL_ADD}`} className="text-sm transition hover:text-white">
                        {OFFICE_HOURS}
                        </a>
                    </div>
                </div>
                <div>
                    <a
                        href='https://facebook.com/quilatonlawoffice'
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-5 py-3 font-bold text-zinc-400 transition duration-300 hover:bg-zinc-800 hover:text-white"
                    >f</a>
                    <a
                        href='https://linkedin.com/in/atty-abelardo-quilaton-jr-5a3b25248/'
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-5 py-3 font-bold text-zinc-400 transition duration-300 hover:bg-zinc-800 hover:text-white"
                    >in</a>
                    <a
                        href='/contact/'
                        target="_blank"
                        rel="noopener noreferrer"
                        className="border border-zinc-600 bg-gradient-to-b from-zinc-700 to-zinc-900 px-5 py-2.5 text-white shadow-inner transition duration-300 hover:border-zinc-300"
                    ><small>BOOK AN APPOINTMENT</small></a>
               </div>
            </div>
        </div>
    )

}
